(function(){
var cfg=window.SEOULE||{};
var $=function(s){return document.querySelector(s)};
function esc(t){return String(t==null?'':t).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}

// announcement bar
var trk=$('#trk');
if(trk){var txt=esc(cfg.announcement||''),m='<span>'+txt+'</span><b></b>',g='';for(var i=0;i<6;i++)g+=m;
trk.innerHTML='<div style="display:flex">'+g+'</div><div style="display:flex" aria-hidden="true">'+g+'</div>'}

// header + progress bar
var hd=$('#hd'),pg=$('#pg');
addEventListener('scroll',function(){if(hd)hd.classList.toggle('s',scrollY>40);var d=document.documentElement.scrollHeight-innerHeight;if(pg)pg.style.transform='scaleX('+(d>0?scrollY/d:0)+')'},{passive:true});

// money
function num(c,d,t,p){d=d==null?2:d;t=t==null?',':t;p=p||'.';var x=(c/100).toFixed(d).split('.');x[0]=x[0].replace(/(\d)(?=(\d{3})+$)/g,'$1'+t);return x[0]+(x[1]?p+x[1]:'')}
function fmt(c){var f=(cfg.moneyFormat||'R{{amount}}').replace(/<[^>]*>/g,'');
return f.replace(/\{\{\s*(\w+)\s*\}\}/,function(_,k){switch(k){
case 'amount_no_decimals':return num(c,0);
case 'amount_with_comma_separator':return num(c,2,'.',',');
case 'amount_no_decimals_with_comma_separator':return num(c,0,'.',',');
case 'amount_with_space_separator':return num(c,2,' ','.');
case 'amount_no_decimals_with_space_separator':return num(c,0,' ');
case 'amount_with_apostrophe_separator':return num(c,2,"'",'.');
default:return num(c)}})}

// cart
var cart=null;
function json(r){if(!r.ok)throw new Error('cart');return r.json()}
function refresh(){return fetch(cfg.cartUrl+'.js',{headers:{Accept:'application/json'}}).then(json).then(function(c){cart=c;render();return c})}
function add(id,q){return fetch(cfg.cartAddUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:id,quantity:q||1}]})}).then(json).then(refresh)}
function change(key,q){return fetch(cfg.cartChangeUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:q})}).then(json).then(function(c){cart=c;render()})}
function render(){var n=cart?cart.item_count:0,c=$('#cc');
if(c){c.hidden=!n;c.textContent=n}
var sub=$('#sub');if(sub)sub.textContent=fmt(cart?cart.total_price:0);
var db=$('#db');if(!db)return;
db.innerHTML=n?cart.items.map(function(it){
var img=it.image?'<img src="'+esc(it.image)+'" alt="'+esc(it.product_title)+'" width="64" height="64">':'<span></span>';
var was=it.original_price>it.final_price?'<s class="was">'+fmt(it.original_price)+'</s>':'';
return '<div class="cl">'+img+'<div><h4>'+esc(it.product_title)+'</h4>'+(it.variant_title?'<span class="sm">'+esc(it.variant_title)+'</span><br>':'')+'<span class="sm">'+was+fmt(it.final_price)+' each</span></div>'+
'<div class="qty" style="margin:0"><button data-k="'+esc(it.key)+'" data-q="'+(it.quantity-1)+'" aria-label="Decrease">\u2212</button><span>'+it.quantity+'</span><button data-k="'+esc(it.key)+'" data-q="'+(it.quantity+1)+'" aria-label="Increase">+</button></div></div>'}).join('')
:'<p class="mut" style="padding:28px 0">Your cart is empty.</p>'}
function open_(){render();document.body.classList.add('op');var d=$('#dr');if(d){d.setAttribute('aria-hidden','false');d.focus()}}
function close_(){document.body.classList.remove('op');var d=$('#dr');if(d)d.setAttribute('aria-hidden','true')}
var co=$('#co'),cx=$('#cx'),bk=$('#bk'),db=$('#db');
if(co)co.onclick=function(){refresh().then(open_,open_)};
if(cx)cx.onclick=close_;if(bk)bk.onclick=close_;
addEventListener('keydown',function(e){if(e.key==='Escape')close_()});
if(db)db.addEventListener('click',function(e){var b=e.target.closest('button[data-k]');if(b)change(b.dataset.k,Math.max(0,+b.dataset.q))});
window.Seoule={add:add,open:function(){open_()},close:close_,refresh:refresh,fmt:fmt};
refresh().catch(function(){});
})();
